
import { Dealer, DealerDealerGroupInfo, UpdateDealer } from '../../Models/Dealer';
import { DealerGroup } from '../../Models/DealerGroup';

/************************   Begin Dealer    ******************************/

// CREATE Dealer
export const CREATE_DEALER = 'CREATE_DEALER';
export const CREATE_DEALER_SUCCESS = 'CREATE_DEALER_SUCCESS';
export interface CreateDealerAction {
  type: typeof CREATE_DEALER;
  payload: { dealer: UpdateDealer };
}
export const createDealer = (dealer: UpdateDealer): CreateDealerAction => {
  return {
    type: CREATE_DEALER,
    payload: {dealer}
  };
}
export interface CreateDealerSuccessAction {
  type: typeof CREATE_DEALER_SUCCESS;
  payload: { dealer: Dealer };
}
export const createDealerSuccess = (dealer: Dealer): CreateDealerSuccessAction => {
  return {
    type: CREATE_DEALER_SUCCESS,
    payload: { dealer }
  };
}

// Load All Dealers
export const LOAD_ALL_DEALERS = 'LOAD_ALL_DEALERS';
export const LOAD_ALL_DEALERS_SUCCESS = 'LOAD_ALL_DEALERS_SUCCESS';
export interface LoadAllDealersAction {
  type: typeof LOAD_ALL_DEALERS; 
}
export const loadAllDealers = (): LoadAllDealersAction => {
  return {
    type: LOAD_ALL_DEALERS
  };
}
export interface LoadAllDealersSuccessAction {
  type: typeof LOAD_ALL_DEALERS_SUCCESS;
  payload: { dealers: Dealer[] };
}
export const loadAllDealersSuccess = (dealers: Dealer[]): LoadAllDealersSuccessAction => {
  return {
    type: LOAD_ALL_DEALERS_SUCCESS,
    payload: { dealers }
  };
}


// LOAD Dealer
export const LOAD_DEALER = 'LOAD_DEALER';
export const LOAD_DEALER_SUCCESS = 'LOAD_DEALER_SUCCESS';
export interface LoadDealersAction {
  type: typeof LOAD_DEALER;
  payload: {  };
}
export const loadDealer = (): LoadDealersAction => {
  return {
    type: LOAD_DEALER,
    payload: { }
  };
}
export interface LoadDealersSuccessAction {
  type: typeof LOAD_DEALER_SUCCESS;
  payload: { dealer: Dealer };
}
export const loadDealerSuccess = (dealer: Dealer): LoadDealersSuccessAction => {
  return {
    type: LOAD_DEALER_SUCCESS,
    payload: { dealer }
  };
}

// UPDATE Dealer
export const UPDATE_DEALER = 'UPDATE_DEALER';
export const UPDATE_DEALER_SUCCESS = 'UPDATE_DEALER_SUCCESS';
export interface UpdateDealerAction {
  type: typeof UPDATE_DEALER;
  payload: { dealer: UpdateDealer };
}
export const updateDealer = (dealer: UpdateDealer): UpdateDealerAction => {
  return {
    type: UPDATE_DEALER,
    payload: { dealer }
  };
}
export interface UpdateDealerSuccessAction {
  type: typeof UPDATE_DEALER_SUCCESS;
  payload: { dealer: Dealer };
}
export const updateDealerSuccess = (dealer: Dealer): UpdateDealerSuccessAction => {
  return {
    type: UPDATE_DEALER_SUCCESS,
    payload: { dealer }
  };
}

// Load All Dealer Groups
export const LOAD_ALL_DEALER_GROUPS = 'LOAD_ALL_DEALER_GROUPS';
export const LOAD_ALL_DEALER_GROUPS_SUCCESS = 'LOAD_ALL_DEALER_GROUPS_SUCCESS';
export interface LoadAllDealerGroupsAction {
  type: typeof LOAD_ALL_DEALER_GROUPS; 
}
export const loadAllDealerGroups = (): LoadAllDealerGroupsAction => {
  return {
    type: LOAD_ALL_DEALER_GROUPS
  };
}
export interface LoadAllDealerGroupsSuccessAction {
  type: typeof LOAD_ALL_DEALER_GROUPS_SUCCESS;
  payload: { dealerGroups: DealerGroup[] };
}
export const loadAllDealerGroupsSuccess = (dealerGroups: DealerGroup[]): LoadAllDealerGroupsSuccessAction => {
  return {
    type: LOAD_ALL_DEALER_GROUPS_SUCCESS,
    payload: { dealerGroups }
  };
}

// create dealer group
export const CREATE_DEALER_GROUP = 'CREATE_DEALER_GROUP';
export const CREATE_DEALER_GROUP_SUCCESS = 'CREATE_DEALER_GROUP_SUCCESS';
export interface CreateDealerGroupAction {
  type: typeof CREATE_DEALER_GROUP;
  payload: { dealerGroup: DealerGroup };
}
export const createDealerGroup = (dealerGroup: DealerGroup): CreateDealerGroupAction => {
  return {
    type: CREATE_DEALER_GROUP,
    payload: { dealerGroup }
  };
}
export interface CreateDealerGroupSuccessAction {
  type: typeof CREATE_DEALER_GROUP_SUCCESS;
  payload: { dealerGroup: DealerGroup };
}
export const createDealerGroupSuccess = (dealerGroup: DealerGroup): CreateDealerGroupSuccessAction => {
  return {
    type: CREATE_DEALER_GROUP_SUCCESS,
    payload: { dealerGroup }
  };
}

// update dealer group
export const UPDATE_DEALER_GROUP = 'UPDATE_DEALER_GROUP';
export const UPDATE_DEALER_GROUP_SUCCESS = 'UPDATE_DEALER_GROUP_SUCCESS';
export interface UpdateDealerGroupAction {
  type: typeof UPDATE_DEALER_GROUP;
  payload: { dealerGroup: DealerGroup };
}
export const updateDealerGroup = (dealerGroup: DealerGroup): UpdateDealerGroupAction => {
  return {
    type: UPDATE_DEALER_GROUP,
    payload: { dealerGroup }
  };
}
export interface UpdateDealerGroupSuccessAction {
  type: typeof UPDATE_DEALER_GROUP_SUCCESS;
  payload: { dealerGroup: DealerGroup };
}
export const updateDealerGroupSuccess = (dealerGroup: DealerGroup): UpdateDealerGroupSuccessAction => {
  return {
    type: UPDATE_DEALER_GROUP_SUCCESS,
    payload: { dealerGroup }
  };
}

// Add Dealers to Dealer Group
export const ADD_DEALER_TO_DEALER_GROUP = 'ADD_DEALER_TO_DEALER_GROUP';
export const ADD_DEALER_TO_DEALER_GROUP_SUCCESS = 'ADD_DEALER_TO_DEALER_GROUP_SUCCESS';
export interface AddDealerToDealerGroupAction {
  type: typeof ADD_DEALER_TO_DEALER_GROUP;
  payload: { dealerDealerGroup: DealerDealerGroupInfo };
}
export const addDealerToDealerGroup = (dealerDealerGroup: DealerDealerGroupInfo): AddDealerToDealerGroupAction => {
  return {
    type: ADD_DEALER_TO_DEALER_GROUP,
    payload: { dealerDealerGroup }
  };
}
export interface AddDealersToDealerGroupSuccessAction {
  type: typeof ADD_DEALER_TO_DEALER_GROUP_SUCCESS;
  payload: { dealerDealerGroup: DealerDealerGroupInfo };
}
export const addDealerToDealerGroupSuccess = (dealerDealerGroup: DealerDealerGroupInfo): AddDealersToDealerGroupSuccessAction => {
  return {
    type: ADD_DEALER_TO_DEALER_GROUP_SUCCESS,
    payload: { dealerDealerGroup }
  };
}

// Remove Dealer from Dealer Group
export const REMOVE_DEALER_FROM_DEALER_GROUP = 'REMOVE_DEALER_FROM_DEALER_GROUP';
export const REMOVE_DEALER_FROM_DEALER_GROUP_SUCCESS = 'REMOVE_DEALER_FROM_DEALER_GROUP_SUCCESS';
export interface RemoveDealerFromDealerGroupAction {
  type: typeof REMOVE_DEALER_FROM_DEALER_GROUP;
  payload: { dealerId: string, dealerGroupId: string };
}
export const removeDealerFromDealerGroup = (dealerId: string, dealerGroupId: string): RemoveDealerFromDealerGroupAction => {
  return {
    type: REMOVE_DEALER_FROM_DEALER_GROUP,
    payload: { dealerId, dealerGroupId }
  };
}
export interface RemoveDealerFromDealerGroupSuccessAction {
  type: typeof REMOVE_DEALER_FROM_DEALER_GROUP_SUCCESS;
  payload: { dealerId: string, dealerGroupId: string };
}
export const removeDealerFromDealerGroupSuccess = (dealerId: string, dealerGroupId: string): RemoveDealerFromDealerGroupSuccessAction => {
  return {
    type: REMOVE_DEALER_FROM_DEALER_GROUP_SUCCESS,
    payload: { dealerId, dealerGroupId }
  };
}


// Update Dealer Dealer Group Member
export const UPDATE_DEALER_DEALER_GROUP_MEMBER = 'UPDATE_DEALER_DEALER_GROUP_MEMBER';
export const UPDATE_DEALER_DEALER_GROUP_MEMBER_SUCCESS = 'UPDATE_DEALER_DEALER_GROUP_MEMBER_SUCCESS';
export interface UpdateDealerDealerGroupMemberAction {
  type: typeof UPDATE_DEALER_DEALER_GROUP_MEMBER;
  payload: { dealerDealerGroup: DealerDealerGroupInfo };
}
export const updateDealerDealerGroupMember = (dealerDealerGroup: DealerDealerGroupInfo): UpdateDealerDealerGroupMemberAction => {
  return {
    type: UPDATE_DEALER_DEALER_GROUP_MEMBER,
    payload: { dealerDealerGroup }
  };
}
export interface UpdateDealerDealerGroupMemberSuccessAction {
  type: typeof UPDATE_DEALER_DEALER_GROUP_MEMBER_SUCCESS;
  payload: { dealerDealerGroup: DealerDealerGroupInfo };
}
export const updateDealerDealerGroupMemberSuccess = (dealerDealerGroup: DealerDealerGroupInfo): UpdateDealerDealerGroupMemberSuccessAction => {
  return {
    type: UPDATE_DEALER_DEALER_GROUP_MEMBER_SUCCESS,
    payload: { dealerDealerGroup }
  };
}


/************************   End Dealer    ******************************/

export type DealerAction = 
  CreateDealerAction
  | CreateDealerSuccessAction
  | LoadDealersAction
  | LoadDealersSuccessAction
  | LoadAllDealersAction
  | LoadAllDealersSuccessAction
  | LoadAllDealerGroupsSuccessAction
  | UpdateDealerSuccessAction
  | UpdateDealerGroupSuccessAction
  | CreateDealerGroupSuccessAction
  | AddDealersToDealerGroupSuccessAction
  | RemoveDealerFromDealerGroupSuccessAction
  | UpdateDealerDealerGroupMemberSuccessAction;
